import React from 'react';

import { Alert } from 'react-bootstrap';
import { useIntl } from 'react-intl';

interface IPermissionDeniedProps {
  sectionName: string;
}

const PermissionDenied = ({ sectionName }: IPermissionDeniedProps) => {
  const intl = useIntl();
  return (
    <Alert variant="danger">
      <div
        data-test="permission-denied"
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage(
            { id: 'permissionDeniedKey' },
            { section: `<b>${sectionName}</b>` }
          )
        }}
      />
    </Alert>
  );
};

export default PermissionDenied;
